import AxiosCustom from "../../../components/common/apiConfigPouyan/index";


export function register_trading_system(payload) {
  const config = {
    url: `/TradingSystem/RegisterTradingSystem/Register?tradingSystemId=${payload?.data?.tradingSystemId}`
  };

  const data = {};

  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
